import PropTypes from 'prop-types';

const ICON_PROP_TYPES = {
  className: PropTypes.string,
  fill: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string
};

export const CrossIcon = props => {
  const { fill, className, width, height } = props;
  return (
    <svg
      viewBox="0 0 16 16"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      className={className}
    >
      <g
        className={className}
        id="ic_close"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g id="Group-2" stroke="#000000" strokeOpacity="0.00784313771" strokeWidth="0.5">
          <polygon id="Stroke-1" points="0 0 16 0 16 16 0 16" />
        </g>
        <path
          d="M2.5,2.5 L13.5,13.5"
          id="Path-3"
          stroke={fill}
          strokeWidth="1.25"
          strokeLinecap="round"
          fillRule="nonzero"
          fill={fill}
        />
        <path
          d="M2.5,2.5 L13.5,13.5"
          id="Path-3-Copy"
          stroke={fill}
          strokeWidth="1.25"
          strokeLinecap="round"
          fillRule="nonzero"
          transform="translate(8.000000, 8.000000) scale(-1, 1) translate(-8.000000, -8.000000) "
          fill={fill}
        />
      </g>
    </svg>
  );
};

CrossIcon.defaultProps = {
  className: '',
  fill: '',
  width: '16px',
  height: '16px'
};

CrossIcon.propTypes = ICON_PROP_TYPES;

export const CheckIcon = props => {
  const { className, fill, width, height } = props;
  return (
    <svg
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 512 512"
      height={height}
      width={width}
      className={className}
      {...props}
    >
      <path
        fill={fill}
        d="M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z"
      />
    </svg>
  );
};

CheckIcon.defaultProps = {
  className: '',
  fill: '',
  width: '16px',
  height: '16px'
};

CheckIcon.propTypes = ICON_PROP_TYPES;

export const HomeIcon = props => {
  const { className, fill } = props;

  return (
    <svg
      width="16px"
      height="16px"
      viewBox="0 0 576 512"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fill={fill}
        d="M280.37 148.26L96 300.11V464a16 16 0 0 0 16 16l112.06-.29a16 16 0 0 0 15.92-16V368a16 16 0 0 1 16-16h64a16 16 0 0 1 16 16v95.64a16 16 0 0 0 16 16.05L464 480a16 16 0 0 0 16-16V300L295.67 148.26a12.19 12.19 0 0 0-15.3 0zM571.6 251.47L488 182.56V44.05a12 12 0 0 0-12-12h-56a12 12 0 0 0-12 12v72.61L318.47 43a48 48 0 0 0-61 0L4.34 251.47a12 12 0 0 0-1.6 16.9l25.5 31A12 12 0 0 0 45.15 301l235.22-193.74a12.19 12.19 0 0 1 15.3 0L530.9 301a12 12 0 0 0 16.9-1.6l25.5-31a12 12 0 0 0-1.7-16.93z"
      />
    </svg>
  );
};

HomeIcon.defaultProps = {
  className: '',
  fill: ''
};

HomeIcon.propTypes = {
  className: PropTypes.string,
  fill: PropTypes.string
};

export const AdsIcon = props => {
  const { className, fill, width, height } = props;

  return (
    <svg
      className={className}
      width={width}
      height={height}
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 512 512"
    >
      <path
        fill={fill}
        d="M157.52 272h36.96L176 218.78 157.52 272zM352 256c-13.23 0-24 10.77-24 24s10.77 24 24 24 24-10.77 24-24-10.77-24-24-24zM464 64H48C21.5 64 0 85.5 0 112v288c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zM250.58 352h-16.94c-6.81 0-12.88-4.32-15.12-10.75L211.15 320h-70.29l-7.38 21.25A16 16 0 0 1 118.36 352h-16.94c-11.01 0-18.73-10.85-15.12-21.25L140 176.12A23.995 23.995 0 0 1 162.67 160h26.66A23.99 23.99 0 0 1 212 176.13l53.69 154.62c3.61 10.4-4.11 21.25-15.11 21.25zM424 336c0 8.84-7.16 16-16 16h-16c-4.85 0-9.04-2.27-11.98-5.68-8.62 3.66-18.09 5.68-28.02 5.68-39.7 0-72-32.3-72-72s32.3-72 72-72c8.46 0 16.46 1.73 24 4.42V176c0-8.84 7.16-16 16-16h16c8.84 0 16 7.16 16 16v160z"
      />
    </svg>
  );
};

AdsIcon.defaultProps = {
  className: '',
  fill: '',
  width: '16px',
  height: '16px'
};

AdsIcon.propTypes = ICON_PROP_TYPES;

export const CartIcon = props => {
  const { className, fill, width, height } = props;
  return (
    <svg
      className={className}
      width={width}
      height={height}
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 576 512"
    >
      <path
        fill={fill}
        d="M528.12 301.319l47.273-208C578.806 78.301 567.391 64 551.99 64H159.208l-9.166-44.81C147.758 8.021 137.93 0 126.529 0H24C10.745 0 0 10.745 0 24v16c0 13.255 10.745 24 24 24h69.883l70.248 343.435C147.325 417.1 136 435.222 136 456c0 30.928 25.072 56 56 56s56-25.072 56-56c0-15.674-6.447-29.835-16.824-40h209.647C430.447 426.165 424 440.326 424 456c0 30.928 25.072 56 56 56s56-25.072 56-56c0-22.172-12.888-41.332-31.579-50.405l5.517-24.276c3.413-15.018-8.002-29.319-23.403-29.319H218.117l-6.545-32h293.145c11.206 0 20.92-7.754 23.403-18.681z"
      />
    </svg>
  );
};

CartIcon.defaultProps = {
  className: '',
  fill: '',
  width: '16px',
  height: '16px'
};

CartIcon.propTypes = ICON_PROP_TYPES;

export const ProductsIcon = props => {
  const { className, fill, width, height } = props;
  return (
    <svg
      className={className}
      width={width}
      height={height}
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 512 512"
    >
      <path
        fill={fill}
        d="M12.41 148.02l232.94 105.67c6.8 3.09 14.49 3.09 21.29 0l232.94-105.67c16.55-7.51 16.55-32.52 0-40.03L266.65 2.31a25.607 25.607 0 0 0-21.29 0L12.41 107.98c-16.55 7.51-16.55 32.53 0 40.04zm487.18 88.28l-58.09-26.33-161.64 73.27c-7.56 3.43-15.59 5.17-23.86 5.17s-16.29-1.74-23.86-5.17L70.51 209.97l-58.1 26.33c-16.55 7.5-16.55 32.5 0 40l232.94 105.59c6.8 3.08 14.49 3.08 21.29 0L499.59 276.3c16.55-7.5 16.55-32.5 0-40zm0 127.8l-57.87-26.23-161.86 73.37c-7.56 3.43-15.59 5.17-23.86 5.17s-16.29-1.74-23.86-5.17L70.29 337.87 12.41 364.1c-16.55 7.5-16.55 32.5 0 40l232.94 105.59c6.8 3.08 14.49 3.08 21.29 0L499.59 404.1c16.55-7.5 16.55-32.5 0-40z"
      />
    </svg>
  );
};

ProductsIcon.defaultProps = {
  className: '',
  fill: '',
  width: '16px',
  height: '16px'
};

ProductsIcon.propTypes = ICON_PROP_TYPES;

export const ExchangeAltIcon = props => {
  const { className, fill, width, height } = props;
  return (
    <svg
      className={className}
      width={width}
      height={height}
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 512 512"
    >
      <path
        fill={fill}
        d="M0 168v-16c0-13.255 10.745-24 24-24h360V80c0-21.367 25.899-32.042 40.971-16.971l80 80c9.372 9.373 9.372 24.569 0 33.941l-80 80C409.956 271.982 384 261.456 384 240v-48H24c-13.255 0-24-10.745-24-24zm488 152H128v-48c0-21.314-25.862-32.08-40.971-16.971l-80 80c-9.372 9.373-9.372 24.569 0 33.941l80 80C102.057 463.997 128 453.437 128 432v-48h360c13.255 0 24-10.745 24-24v-16c0-13.255-10.745-24-24-24z"
      />
    </svg>
  );
};

ExchangeAltIcon.defaultProps = {
  className: '',
  fill: '',
  width: '16px',
  height: '16px'
};

ExchangeAltIcon.propTypes = ICON_PROP_TYPES;

export const VatIcon = props => {
  const { className, fill } = props;

  return (
    <svg
      width="16px"
      height="16px"
      viewBox="0 0 16 16"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g id="ic_vat" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Group-17" transform="translate(1.000000, 1.000000)">
          <g id="Group-3">
            <g id="Clip-2" />
            <path
              d="M0.25,0.25 L0.25,13.7500006 L13.7500006,13.7500006 L13.7500006,0.25 L0.25,0.25 Z M14.2500006,-0.25 L14.2500006,14.2500006 L-0.25,14.2500006 L-0.25,-0.25 L14.2500006,-0.25 Z"
              id="Stroke-1"
              fillOpacity="0.0117647061"
              fill={fill}
              fillRule="nonzero"
              mask="url(#mask-2)"
            />
          </g>
          <g
            id="Group-16"
            transform="translate(1.750000, 0.875000)"
            fill="#202124"
            fillRule="nonzero"
          >
            <path
              d="M7.08842678,12.2083333 L9.875,10.1817346 L9.875,0.625 L0.625,0.625 L0.625,12.2083333 L7.08842678,12.2083333 Z M7.29166667,13.4583333 L0.583333333,13.4583333 C-0.0840106369,13.4583333 -0.625,12.9173437 -0.625,12.25 L-0.625,0.583333333 C-0.625,-0.0840107103 -0.0840107103,-0.625 0.583333333,-0.625 L9.91666667,-0.625 C10.5840104,-0.625 11.125,-0.0840106369 11.125,0.583333333 L11.125,10.5 C11.125,10.6999604 11.0293225,10.887849 10.8676073,11.0054601 L7.65927398,13.3387934 C7.55244878,13.4164844 7.42375573,13.4583333 7.29166667,13.4583333 Z"
              fill={fill}
              id="Stroke-4"
            />
            <path
              d="M7.625,12.25 C7.625,12.595178 7.34517797,12.875 7,12.875 C6.65482203,12.875 6.375,12.595178 6.375,12.25 L6.375,10.2083333 C6.375,9.86315536 6.65482203,9.58333333 7,9.58333333 L10.2083333,9.58333333 C10.5535113,9.58333333 10.8333333,9.86315536 10.8333333,10.2083333 C10.8333333,10.5535113 10.5535113,10.8333333 10.2083333,10.8333333 L7.625,10.8333333 L7.625,12.25 Z"
              fill={fill}
              id="Stroke-6"
            />
            <path
              d="M3.79166667,2.95833333 C3.4464887,2.95833333 3.16666667,2.6785113 3.16666667,2.33333333 C3.16666667,1.98815536 3.4464887,1.70833333 3.79166667,1.70833333 L6.70833333,1.70833333 C7.0535113,1.70833333 7.33333333,1.98815536 7.33333333,2.33333333 C7.33333333,2.6785113 7.0535113,2.95833333 6.70833333,2.95833333 L3.79166667,2.95833333 Z"
              fill={fill}
              id="Stroke-7"
            />
            <path
              d="M1.75,5.29166667 C1.40482203,5.29166667 1.125,5.01184464 1.125,4.66666667 C1.125,4.3214887 1.40482203,4.04166667 1.75,4.04166667 L5.54166667,4.04166667 C5.88684464,4.04166667 6.16666667,4.3214887 6.16666667,4.66666667 C6.16666667,5.01184464 5.88684464,5.29166667 5.54166667,5.29166667 L1.75,5.29166667 Z"
              fill={fill}
              id="Stroke-8"
            />
            <path
              d="M1.75,7.04166667 C1.40482203,7.04166667 1.125,6.76184464 1.125,6.41666667 C1.125,6.0714887 1.40482203,5.79166667 1.75,5.79166667 L5.54166667,5.79166667 C5.88684464,5.79166667 6.16666667,6.0714887 6.16666667,6.41666667 C6.16666667,6.76184464 5.88684464,7.04166667 5.54166667,7.04166667 L1.75,7.04166667 Z"
              fill={fill}
              id="Stroke-9"
            />
            <path
              d="M1.75,8.79166667 C1.40482203,8.79166667 1.125,8.51184464 1.125,8.16666667 C1.125,7.8214887 1.40482203,7.54166667 1.75,7.54166667 L5.54166667,7.54166667 C5.88684464,7.54166667 6.16666667,7.8214887 6.16666667,8.16666667 C6.16666667,8.51184464 5.88684464,8.79166667 5.54166667,8.79166667 L1.75,8.79166667 Z"
              fill={fill}
              id="Stroke-11"
            />
            <path
              d="M7.875,5.29166667 C7.52982203,5.29166667 7.25,5.01184464 7.25,4.66666667 C7.25,4.3214887 7.52982203,4.04166667 7.875,4.04166667 L8.75,4.04166667 C9.09517797,4.04166667 9.375,4.3214887 9.375,4.66666667 C9.375,5.01184464 9.09517797,5.29166667 8.75,5.29166667 L7.875,5.29166667 Z"
              fill={fill}
              id="Stroke-12"
            />
            <path
              d="M7.875,7.04166667 C7.52982203,7.04166667 7.25,6.76184464 7.25,6.41666667 C7.25,6.0714887 7.52982203,5.79166667 7.875,5.79166667 L8.75,5.79166667 C9.09517797,5.79166667 9.375,6.0714887 9.375,6.41666667 C9.375,6.76184464 9.09517797,7.04166667 8.75,7.04166667 L7.875,7.04166667 Z"
              fill={fill}
              id="Stroke-13"
            />
            <path
              d="M7.875,8.79166667 C7.52982203,8.79166667 7.25,8.51184464 7.25,8.16666667 C7.25,7.8214887 7.52982203,7.54166667 7.875,7.54166667 L8.75,7.54166667 C9.09517797,7.54166667 9.375,7.8214887 9.375,8.16666667 C9.375,8.51184464 9.09517797,8.79166667 8.75,8.79166667 L7.875,8.79166667 Z"
              fill={fill}
              id="Stroke-15"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

VatIcon.defaultProps = {
  className: '',
  fill: ''
};

VatIcon.propTypes = {
  className: PropTypes.string,
  fill: PropTypes.string
};

export const UserSecretIcon = props => {
  const { className, fill, width, height } = props;

  return (
    <svg
      width={width}
      height={height}
      className={className}
      preserveAspectRatio="xMidYMid meet"
      viewBox="0 0 1408 1664"
    >
      <path
        d="M576 1536l96-448l-96-128l-128-64zm256 0l128-640l-128 64l-96 128zM992 526q-2-4-4-6q-10-8-96-8q-70 0-167 19q-7 2-21 2t-21-2q-97-19-167-19q-86 0-96 8q-2 2-4 6q2 18 4 27q2 3 7.5 6.5T435 570q2 4 7.5 20.5t7 20.5t7.5 17t8.5 17t9 14t12 13.5t14 9.5t17.5 8t20.5 4t24.5 2q36 0 59-12.5t32.5-30T669 619t11.5-29.5T698 577h12q11 0 17.5 12.5T739 619t14.5 34.5t32.5 30t59 12.5q13 0 24.5-2t20.5-4t17.5-8t14-9.5t12-13.5t9-14t8.5-17t7.5-17t7-20.5T973 570q2-7 7.5-10.5t7.5-6.5q2-9 4-27zm416 879q0 121-73 190t-194 69H267q-121 0-194-69T0 1405q0-61 4.5-118t19-125.5T61 1038t63.5-103.5T218 860l-90-220h214q-22-64-22-128q0-12 2-32q-194-40-194-96q0-57 210-99q17-62 51.5-134T460 37q32-37 76-37q30 0 84 31t84 31t84-31t84-31q44 0 76 37q36 42 70.5 114t51.5 134q210 42 210 99q0 56-194 96q7 81-20 160h214l-82 225q63 33 107.5 96.5T1371 1105t29 151.5t8 148.5z"
        fill={fill}
      />
    </svg>
  );
};

UserSecretIcon.defaultProps = {
  className: '',
  fill: '',
  width: '16px',
  height: '16px'
};

UserSecretIcon.propTypes = ICON_PROP_TYPES;

export const CaretDownIcon = props => {
  const { className, fill, width, height } = props;

  return (
    <svg
      width={width}
      height={height}
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      viewBox="0 0 320 512"
    >
      <path
        fill={fill}
        d="M31.3 192h257.3c17.8 0 26.7 21.5 14.1 34.1L174.1 354.8c-7.8 7.8-20.5 7.8-28.3 0L17.2 226.1C4.6 213.5 13.5 192 31.3 192z"
      />
    </svg>
  );
};

CaretDownIcon.defaultProps = {
  className: '',
  fill: '',
  width: '16px',
  height: '16px'
};

CaretDownIcon.propTypes = ICON_PROP_TYPES;

export const EnvelopeIcon = props => {
  const { className, fill, width, height } = props;
  return (
    <svg
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 512 512"
      height={height}
      width={width}
      className={className}
    >
      <path
        fill={fill}
        d="M502.3 190.8c3.9-3.1 9.7-.2 9.7 4.7V400c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V195.6c0-5 5.7-7.8 9.7-4.7 22.4 17.4 52.1 39.5 154.1 113.6 21.1 15.4 56.7 47.8 92.2 47.6 35.7.3 72-32.8 92.3-47.6 102-74.1 131.6-96.3 154-113.7zM256 320c23.2.4 56.6-29.2 73.4-41.4 132.7-96.3 142.8-104.7 173.4-128.7 5.8-4.5 9.2-11.5 9.2-18.9v-19c0-26.5-21.5-48-48-48H48C21.5 64 0 85.5 0 112v19c0 7.4 3.4 14.3 9.2 18.9 30.6 23.9 40.7 32.4 173.4 128.7 16.8 12.2 50.2 41.8 73.4 41.4z"
      />
    </svg>
  );
};

EnvelopeIcon.defaultProps = {
  className: '',
  fill: '',
  width: '16px',
  height: '16px'
};

EnvelopeIcon.propTypes = ICON_PROP_TYPES;

export const LockIcon = props => {
  const { className, fill, width, height } = props;
  return (
    <svg
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 448 512"
      height={height}
      width={width}
      className={className}
    >
      <path
        fill={fill}
        d="M400 224h-24v-72C376 68.2 307.8 0 224 0S72 68.2 72 152v72H48c-26.5 0-48 21.5-48 48v192c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V272c0-26.5-21.5-48-48-48zm-104 0H152v-72c0-39.7 32.3-72 72-72s72 32.3 72 72v72z"
      />
    </svg>
  );
};

LockIcon.defaultProps = {
  className: '',
  fill: '',
  width: '16px',
  height: '16px'
};

LockIcon.propTypes = ICON_PROP_TYPES;

export const FacebookIcon = props => {
  const { className, fill, width, height } = props;
  return (
    <svg
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 448 512"
      className={className}
      width={width}
      height={height}
    >
      <path
        fill={fill}
        d="M400 32H48A48 48 0 0 0 0 80v352a48 48 0 0 0 48 48h137.25V327.69h-63V256h63v-54.64c0-62.15 37-96.48 93.67-96.48 27.14 0 55.52 4.84 55.52 4.84v61h-31.27c-30.81 0-40.42 19.12-40.42 38.73V256h68.78l-11 71.69h-57.78V480H400a48 48 0 0 0 48-48V80a48 48 0 0 0-48-48z"
      />
    </svg>
  );
};

FacebookIcon.defaultProps = {
  className: '',
  fill: '',
  width: '16px',
  height: '16px'
};

FacebookIcon.propTypes = ICON_PROP_TYPES;

export const GoogleIcon = props => {
  const { className, fill, width, height } = props;
  return (
    <svg
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 488 512"
      className={className}
      width={width}
      height={height}
    >
      <path
        fill={fill}
        d="M488 261.8C488 403.3 391.1 504 248 504 110.8 504 0 393.2 0 256S110.8 8 248 8c66.8 0 123 24.5 166.3 64.9l-67.5 64.9C258.5 52.6 94.3 116.6 94.3 256c0 86.5 69.1 156.6 153.7 156.6 98.2 0 135-70.4 140.8-106.9H248v-85.3h236.1c2.3 12.7 3.9 24.9 3.9 41.4z"
      />
    </svg>
  );
};

GoogleIcon.defaultProps = {
  className: '',
  fill: '',
  width: '16px',
  height: '16px'
};

GoogleIcon.propTypes = ICON_PROP_TYPES;

export const ChevronLeftIcon = props => {
  const { className, fill, width, height } = props;
  return (
    <svg
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 320 512"
      height={height}
      width={width}
      className={className}
    >
      <path
        fill={fill}
        d="M34.52 239.03L228.87 44.69c9.37-9.37 24.57-9.37 33.94 0l22.67 22.67c9.36 9.36 9.37 24.52.04 33.9L131.49 256l154.02 154.75c9.34 9.38 9.32 24.54-.04 33.9l-22.67 22.67c-9.37 9.37-24.57 9.37-33.94 0L34.52 272.97c-9.37-9.37-9.37-24.57 0-33.94z"
      />
    </svg>
  );
};

ChevronLeftIcon.defaultProps = {
  className: '',
  fill: '',
  width: '16px',
  height: '16px'
};

ChevronLeftIcon.propTypes = ICON_PROP_TYPES;

export const ChevronRightIcon = props => {
  const { className, fill, width, height } = props;
  return (
    <svg
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 320 512"
      className={className}
      width={width}
      height={height}
    >
      <path
        fill={fill}
        d="M285.476 272.971L91.132 467.314c-9.373 9.373-24.569 9.373-33.941 0l-22.667-22.667c-9.357-9.357-9.375-24.522-.04-33.901L188.505 256 34.484 101.255c-9.335-9.379-9.317-24.544.04-33.901l22.667-22.667c9.373-9.373 24.569-9.373 33.941 0L285.475 239.03c9.373 9.372 9.373 24.568.001 33.941z"
      />
    </svg>
  );
};

ChevronRightIcon.defaultProps = {
  className: '',
  fill: '',
  width: '16px',
  height: '16px'
};

ChevronRightIcon.propTypes = ICON_PROP_TYPES;

export const ChevronDownIcon = props => {
  const { className, fill, width, height, ...others } = props;
  return (
    <svg
      className={className}
      width={width}
      height={height}
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 448 512"
      {...others}
    >
      <path
        fill={fill}
        d="M207.029 381.476L12.686 187.132c-9.373-9.373-9.373-24.569 0-33.941l22.667-22.667c9.357-9.357 24.522-9.375 33.901-.04L224 284.505l154.745-154.021c9.379-9.335 24.544-9.317 33.901.04l22.667 22.667c9.373 9.373 9.373 24.569 0 33.941L240.971 381.476c-9.373 9.372-24.569 9.372-33.942 0z"
      />
    </svg>
  );
};

ChevronDownIcon.defaultProps = {
  className: '',
  fill: '',
  width: '16px',
  height: '16px'
};

ChevronDownIcon.propTypes = ICON_PROP_TYPES;

export const ClockIcon = props => {
  const { className, fill, width, height } = props;
  return (
    <svg
      width={width}
      height={height}
      className={className}
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 512 512"
    >
      <path
        fill={fill}
        d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 448c-110.5 0-200-89.5-200-200S145.5 56 256 56s200 89.5 200 200-89.5 200-200 200zm61.8-104.4l-84.9-61.7c-3.1-2.3-4.9-5.9-4.9-9.7V116c0-6.6 5.4-12 12-12h32c6.6 0 12 5.4 12 12v141.7l66.8 48.6c5.4 3.9 6.5 11.4 2.6 16.8L334.6 349c-3.9 5.3-11.4 6.5-16.8 2.6z"
      />
    </svg>
  );
};

ClockIcon.defaultProps = {
  className: '',
  fill: '',
  width: '16px',
  height: '16px'
};

ClockIcon.propTypes = ICON_PROP_TYPES;

export const IdCardIcon = props => {
  const { className, fill, width, height } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 576 512"
      className={className}
      width={width}
      height={height}
    >
      <path
        fill={fill}
        d="M528 32H48C21.5 32 0 53.5 0 80v16h576V80c0-26.5-21.5-48-48-48zM0 432c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V128H0v304zm352-232c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H360c-4.4 0-8-3.6-8-8v-16zm0 64c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H360c-4.4 0-8-3.6-8-8v-16zm0 64c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H360c-4.4 0-8-3.6-8-8v-16zM176 192c35.3 0 64 28.7 64 64s-28.7 64-64 64-64-28.7-64-64 28.7-64 64-64zM67.1 396.2C75.5 370.5 99.6 352 128 352h8.2c12.3 5.1 25.7 8 39.8 8s27.6-2.9 39.8-8h8.2c28.4 0 52.5 18.5 60.9 44.2 3.2 9.9-5.2 19.8-15.6 19.8H82.7c-10.4 0-18.8-10-15.6-19.8z"
      />
    </svg>
  );
};

IdCardIcon.defaultProps = {
  className: '',
  fill: '',
  width: '16px',
  height: '16px'
};

IdCardIcon.propTypes = ICON_PROP_TYPES;

export const LayersIcon = props => {
  const { className, fill, width, height } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 512 512"
      className={className}
      width={width}
      height={height}
    >
      <path
        fill={fill}
        d="M12.41 148.02l232.94 105.67c6.8 3.09 14.49 3.09 21.29 0l232.94-105.67c16.55-7.51 16.55-32.52 0-40.03L266.65 2.31a25.607 25.607 0 0 0-21.29 0L12.41 107.98c-16.55 7.51-16.55 32.53 0 40.04zm487.18 88.28l-58.09-26.33-161.64 73.27c-7.56 3.43-15.59 5.17-23.86 5.17s-16.29-1.74-23.86-5.17L70.51 209.97l-58.1 26.33c-16.55 7.5-16.55 32.5 0 40l232.94 105.59c6.8 3.08 14.49 3.08 21.29 0L499.59 276.3c16.55-7.5 16.55-32.5 0-40zm0 127.8l-57.87-26.23-161.86 73.37c-7.56 3.43-15.59 5.17-23.86 5.17s-16.29-1.74-23.86-5.17L70.29 337.87 12.41 364.1c-16.55 7.5-16.55 32.5 0 40l232.94 105.59c6.8 3.08 14.49 3.08 21.29 0L499.59 404.1c16.55-7.5 16.55-32.5 0-40z"
      />
    </svg>
  );
};

LayersIcon.defaultProps = {
  className: '',
  fill: '',
  width: '16px',
  height: '16px'
};

LayersIcon.propTypes = ICON_PROP_TYPES;

export const EarthIcon = props => {
  const { className, fill, width, height } = props;
  return (
    <svg
      className={className}
      width={width}
      height={height}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 496 512"
    >
      <path
        fill={fill}
        d="M248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm82.29 357.6c-3.9 3.88-7.99 7.95-11.31 11.28-2.99 3-5.1 6.7-6.17 10.71-1.51 5.66-2.73 11.38-4.77 16.87l-17.39 46.85c-13.76 3-28 4.69-42.65 4.69v-27.38c1.69-12.62-7.64-36.26-22.63-51.25-6-6-9.37-14.14-9.37-22.63v-32.01c0-11.64-6.27-22.34-16.46-27.97-14.37-7.95-34.81-19.06-48.81-26.11-11.48-5.78-22.1-13.14-31.65-21.75l-.8-.72a114.792 114.792 0 0 1-18.06-20.74c-9.38-13.77-24.66-36.42-34.59-51.14 20.47-45.5 57.36-82.04 103.2-101.89l24.01 12.01C203.48 89.74 216 82.01 216 70.11v-11.3c7.99-1.29 16.12-2.11 24.39-2.42l28.3 28.3c6.25 6.25 6.25 16.38 0 22.63L264 112l-10.34 10.34c-3.12 3.12-3.12 8.19 0 11.31l4.69 4.69c3.12 3.12 3.12 8.19 0 11.31l-8 8a8.008 8.008 0 0 1-5.66 2.34h-8.99c-2.08 0-4.08.81-5.58 2.27l-9.92 9.65a8.008 8.008 0 0 0-1.58 9.31l15.59 31.19c2.66 5.32-1.21 11.58-7.15 11.58h-5.64c-1.93 0-3.79-.7-5.24-1.96l-9.28-8.06a16.017 16.017 0 0 0-15.55-3.1l-31.17 10.39a11.95 11.95 0 0 0-8.17 11.34c0 4.53 2.56 8.66 6.61 10.69l11.08 5.54c9.41 4.71 19.79 7.16 30.31 7.16s22.59 27.29 32 32h66.75c8.49 0 16.62 3.37 22.63 9.37l13.69 13.69a30.503 30.503 0 0 1 8.93 21.57 46.536 46.536 0 0 1-13.72 32.98zM417 274.25c-5.79-1.45-10.84-5-14.15-9.97l-17.98-26.97a23.97 23.97 0 0 1 0-26.62l19.59-29.38c2.32-3.47 5.5-6.29 9.24-8.15l12.98-6.49C440.2 193.59 448 223.87 448 256c0 8.67-.74 17.16-1.82 25.54L417 274.25z"
      />
    </svg>
  );
};

EarthIcon.defaultProps = {
  className: '',
  fill: '',
  width: '16px',
  height: '16px'
};

EarthIcon.propTypes = ICON_PROP_TYPES;

export const PenIcon = props => {
  const { className, fill, width, height } = props;
  return (
    <svg
      className={className}
      width={width}
      height={height}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 512 512"
      {...props}
    >
      <path
        fill={fill}
        d="M290.74 93.24l128.02 128.02-277.99 277.99-114.14 12.6C11.35 513.54-1.56 500.62.14 485.34l12.7-114.22 277.9-277.88zm207.2-19.06l-60.11-60.11c-18.75-18.75-49.16-18.75-67.91 0l-56.55 56.55 128.02 128.02 56.55-56.55c18.75-18.76 18.75-49.16 0-67.91z"
      />
    </svg>
  );
};

PenIcon.defaultProps = {
  className: '',
  fill: '',
  width: '16px',
  height: '16px'
};

PenIcon.propTypes = ICON_PROP_TYPES;

export const CrossSolidIcon = props => {
  const { className, fill, width, height } = props;
  return (
    <svg
      className={className}
      height={height}
      width={width}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 352 512"
      {...props}
    >
      <path
        fill={fill}
        d="M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z"
      />
    </svg>
  );
};

CrossSolidIcon.defaultProps = {
  className: '',
  fill: '',
  width: '16px',
  height: '16px'
};

CrossSolidIcon.propTypes = ICON_PROP_TYPES;

export const BanIcon = props => {
  const { className, fill, width, height } = props;
  return (
    <svg
      className={className}
      width={width}
      height={height}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 512 512"
    >
      <path
        fill={fill}
        d="M256 8C119.034 8 8 119.033 8 256s111.034 248 248 248 248-111.034 248-248S392.967 8 256 8zm130.108 117.892c65.448 65.448 70 165.481 20.677 235.637L150.47 105.216c70.204-49.356 170.226-44.735 235.638 20.676zM125.892 386.108c-65.448-65.448-70-165.481-20.677-235.637L361.53 406.784c-70.203 49.356-170.226 44.736-235.638-20.676z"
      />
    </svg>
  );
};

BanIcon.defaultProps = {
  className: '',
  fill: '',
  width: '16px',
  height: '16px'
};

BanIcon.propTypes = ICON_PROP_TYPES;

export const PowerOffIcon = props => {
  const { className, fill, width, height } = props;
  return (
    <svg
      width={width}
      height={height}
      className={className}
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 512 512"
    >
      <path
        fill={fill}
        d="M400 54.1c63 45 104 118.6 104 201.9 0 136.8-110.8 247.7-247.5 248C120 504.3 8.2 393 8 256.4 7.9 173.1 48.9 99.3 111.8 54.2c11.7-8.3 28-4.8 35 7.7L162.6 90c5.9 10.5 3.1 23.8-6.6 31-41.5 30.8-68 79.6-68 134.9-.1 92.3 74.5 168.1 168 168.1 91.6 0 168.6-74.2 168-169.1-.3-51.8-24.7-101.8-68.1-134-9.7-7.2-12.4-20.5-6.5-30.9l15.8-28.1c7-12.4 23.2-16.1 34.8-7.8zM296 264V24c0-13.3-10.7-24-24-24h-32c-13.3 0-24 10.7-24 24v240c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24z"
      />
    </svg>
  );
};

PowerOffIcon.defaultProps = {
  className: '',
  fill: '',
  width: '16px',
  height: '16px'
};

PowerOffIcon.propTypes = ICON_PROP_TYPES;

export const CogsIcon = props => {
  const { className, fill, width, height } = props;
  return (
    <svg
      className={className}
      width={width}
      height={height}
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 640 512"
    >
      <path
        fill={fill}
        d="M512.1 191l-8.2 14.3c-3 5.3-9.4 7.5-15.1 5.4-11.8-4.4-22.6-10.7-32.1-18.6-4.6-3.8-5.8-10.5-2.8-15.7l8.2-14.3c-6.9-8-12.3-17.3-15.9-27.4h-16.5c-6 0-11.2-4.3-12.2-10.3-2-12-2.1-24.6 0-37.1 1-6 6.2-10.4 12.2-10.4h16.5c3.6-10.1 9-19.4 15.9-27.4l-8.2-14.3c-3-5.2-1.9-11.9 2.8-15.7 9.5-7.9 20.4-14.2 32.1-18.6 5.7-2.1 12.1.1 15.1 5.4l8.2 14.3c10.5-1.9 21.2-1.9 31.7 0L552 6.3c3-5.3 9.4-7.5 15.1-5.4 11.8 4.4 22.6 10.7 32.1 18.6 4.6 3.8 5.8 10.5 2.8 15.7l-8.2 14.3c6.9 8 12.3 17.3 15.9 27.4h16.5c6 0 11.2 4.3 12.2 10.3 2 12 2.1 24.6 0 37.1-1 6-6.2 10.4-12.2 10.4h-16.5c-3.6 10.1-9 19.4-15.9 27.4l8.2 14.3c3 5.2 1.9 11.9-2.8 15.7-9.5 7.9-20.4 14.2-32.1 18.6-5.7 2.1-12.1-.1-15.1-5.4l-8.2-14.3c-10.4 1.9-21.2 1.9-31.7 0zm-10.5-58.8c38.5 29.6 82.4-14.3 52.8-52.8-38.5-29.7-82.4 14.3-52.8 52.8zM386.3 286.1l33.7 16.8c10.1 5.8 14.5 18.1 10.5 29.1-8.9 24.2-26.4 46.4-42.6 65.8-7.4 8.9-20.2 11.1-30.3 5.3l-29.1-16.8c-16 13.7-34.6 24.6-54.9 31.7v33.6c0 11.6-8.3 21.6-19.7 23.6-24.6 4.2-50.4 4.4-75.9 0-11.5-2-20-11.9-20-23.6V418c-20.3-7.2-38.9-18-54.9-31.7L74 403c-10 5.8-22.9 3.6-30.3-5.3-16.2-19.4-33.3-41.6-42.2-65.7-4-10.9.4-23.2 10.5-29.1l33.3-16.8c-3.9-20.9-3.9-42.4 0-63.4L12 205.8c-10.1-5.8-14.6-18.1-10.5-29 8.9-24.2 26-46.4 42.2-65.8 7.4-8.9 20.2-11.1 30.3-5.3l29.1 16.8c16-13.7 34.6-24.6 54.9-31.7V57.1c0-11.5 8.2-21.5 19.6-23.5 24.6-4.2 50.5-4.4 76-.1 11.5 2 20 11.9 20 23.6v33.6c20.3 7.2 38.9 18 54.9 31.7l29.1-16.8c10-5.8 22.9-3.6 30.3 5.3 16.2 19.4 33.2 41.6 42.1 65.8 4 10.9.1 23.2-10 29.1l-33.7 16.8c3.9 21 3.9 42.5 0 63.5zm-117.6 21.1c59.2-77-28.7-164.9-105.7-105.7-59.2 77 28.7 164.9 105.7 105.7zm243.4 182.7l-8.2 14.3c-3 5.3-9.4 7.5-15.1 5.4-11.8-4.4-22.6-10.7-32.1-18.6-4.6-3.8-5.8-10.5-2.8-15.7l8.2-14.3c-6.9-8-12.3-17.3-15.9-27.4h-16.5c-6 0-11.2-4.3-12.2-10.3-2-12-2.1-24.6 0-37.1 1-6 6.2-10.4 12.2-10.4h16.5c3.6-10.1 9-19.4 15.9-27.4l-8.2-14.3c-3-5.2-1.9-11.9 2.8-15.7 9.5-7.9 20.4-14.2 32.1-18.6 5.7-2.1 12.1.1 15.1 5.4l8.2 14.3c10.5-1.9 21.2-1.9 31.7 0l8.2-14.3c3-5.3 9.4-7.5 15.1-5.4 11.8 4.4 22.6 10.7 32.1 18.6 4.6 3.8 5.8 10.5 2.8 15.7l-8.2 14.3c6.9 8 12.3 17.3 15.9 27.4h16.5c6 0 11.2 4.3 12.2 10.3 2 12 2.1 24.6 0 37.1-1 6-6.2 10.4-12.2 10.4h-16.5c-3.6 10.1-9 19.4-15.9 27.4l8.2 14.3c3 5.2 1.9 11.9-2.8 15.7-9.5 7.9-20.4 14.2-32.1 18.6-5.7 2.1-12.1-.1-15.1-5.4l-8.2-14.3c-10.4 1.9-21.2 1.9-31.7 0zM501.6 431c38.5 29.6 82.4-14.3 52.8-52.8-38.5-29.6-82.4 14.3-52.8 52.8z"
      />
    </svg>
  );
};

CogsIcon.defaultProps = {
  className: '',
  fill: '',
  width: '16px',
  height: '16px'
};

CogsIcon.propTypes = ICON_PROP_TYPES;

export const UsersIcon = props => {
  const { className, fill, width, height } = props;
  return (
    <svg
      className={className}
      width={width}
      height={height}
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 640 512"
    >
      <path
        fill={fill}
        d="M96 224c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64zm448 0c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64zm32 32h-64c-17.6 0-33.5 7.1-45.1 18.6 40.3 22.1 68.9 62 75.1 109.4h66c17.7 0 32-14.3 32-32v-32c0-35.3-28.7-64-64-64zm-256 0c61.9 0 112-50.1 112-112S381.9 32 320 32 208 82.1 208 144s50.1 112 112 112zm76.8 32h-8.3c-20.8 10-43.9 16-68.5 16s-47.6-6-68.5-16h-8.3C179.6 288 128 339.6 128 403.2V432c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48v-28.8c0-63.6-51.6-115.2-115.2-115.2zm-223.7-13.4C161.5 263.1 145.6 256 128 256H64c-35.3 0-64 28.7-64 64v32c0 17.7 14.3 32 32 32h65.9c6.3-47.4 34.9-87.3 75.2-109.4z"
      />
    </svg>
  );
};

UsersIcon.defaultProps = {
  className: '',
  fill: '',
  width: '16px',
  height: '16px'
};

UsersIcon.propTypes = ICON_PROP_TYPES;

export const WalletIcon = props => {
  const { className, fill, width, height } = props;
  return (
    <svg
      className={className}
      width={width}
      height={height}
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 512 512"
    >
      <path
        fill={fill}
        d="M461.2 128H80c-8.84 0-16-7.16-16-16s7.16-16 16-16h384c8.84 0 16-7.16 16-16 0-26.51-21.49-48-48-48H64C28.65 32 0 60.65 0 96v320c0 35.35 28.65 64 64 64h397.2c28.02 0 50.8-21.53 50.8-48V176c0-26.47-22.78-48-50.8-48zM416 336c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
      />
    </svg>
  );
};

WalletIcon.defaultProps = {
  className: '',
  fill: '',
  width: '16px',
  height: '16px'
};

WalletIcon.propTypes = ICON_PROP_TYPES;

export const UserIcon = props => {
  const { className, fill, width, height } = props;
  return (
    <svg
      className={className}
      width={width}
      height={height}
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 448 512"
    >
      <path
        fill={fill}
        d="M224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm89.6 32h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-74.2-60.2-134.4-134.4-134.4z"
      />
    </svg>
  );
};

UserIcon.defaultProps = {
  className: '',
  fill: '',
  width: '16px',
  height: '16px'
};

UserIcon.propTypes = ICON_PROP_TYPES;

export const AddressCardIcon = props => {
  const { className, fill, width, height } = props;
  return (
    <svg
      className={className}
      width={width}
      height={height}
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 576 512"
    >
      <path
        fill={fill}
        d="M528 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-352 96c35.3 0 64 28.7 64 64s-28.7 64-64 64-64-28.7-64-64 28.7-64 64-64zm112 236.8c0 10.6-10 19.2-22.4 19.2H86.4C74 384 64 375.4 64 364.8v-19.2c0-31.8 30.1-57.6 67.2-57.6h5c12.3 5.1 25.7 8 39.8 8s27.6-2.9 39.8-8h5c37.1 0 67.2 25.8 67.2 57.6v19.2zM512 312c0 4.4-3.6 8-8 8H360c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16zm0-64c0 4.4-3.6 8-8 8H360c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16zm0-64c0 4.4-3.6 8-8 8H360c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16z"
      />
    </svg>
  );
};

AddressCardIcon.defaultProps = {
  className: '',
  fill: '',
  width: '16px',
  height: '16px'
};

AddressCardIcon.propTypes = ICON_PROP_TYPES;

export const ArchiveIcon = props => {
  const { className, fill, width, height } = props;
  return (
    <svg
      className={className}
      width={width}
      height={height}
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 384 512"
    >
      <path
        fill={fill}
        d="M377 105L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1c0-6.3-2.5-12.4-7-16.9zM128.4 336c-17.9 0-32.4 12.1-32.4 27 0 15 14.6 27 32.5 27s32.4-12.1 32.4-27-14.6-27-32.5-27zM224 136V0h-63.6v32h-32V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zM95.9 32h32v32h-32zm32.3 384c-33.2 0-58-30.4-51.4-62.9L96.4 256v-32h32v-32h-32v-32h32v-32h-32V96h32V64h32v32h-32v32h32v32h-32v32h32v32h-32v32h22.1c5.7 0 10.7 4.1 11.8 9.7l17.3 87.7c6.4 32.4-18.4 62.6-51.4 62.6z"
      />
    </svg>
  );
};

ArchiveIcon.defaultProps = {
  className: '',
  fill: '',
  width: '16px',
  height: '16px'
};

ArchiveIcon.propTypes = ICON_PROP_TYPES;

export const ExclamationIcon = props => {
  const { className, fill, width, height } = props;
  return (
    <svg
      className={className}
      width={width}
      height={height}
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 576 512"
    >
      <path
        fill={fill}
        d="M569.517 440.013C587.975 472.007 564.806 512 527.94 512H48.054c-36.937 0-59.999-40.055-41.577-71.987L246.423 23.985c18.467-32.009 64.72-31.951 83.154 0l239.94 416.028zM288 354c-25.405 0-46 20.595-46 46s20.595 46 46 46 46-20.595 46-46-20.595-46-46-46zm-43.673-165.346l7.418 136c.347 6.364 5.609 11.346 11.982 11.346h48.546c6.373 0 11.635-4.982 11.982-11.346l7.418-136c.375-6.874-5.098-12.654-11.982-12.654h-63.383c-6.884 0-12.356 5.78-11.981 12.654z"
      />
    </svg>
  );
};

ExclamationIcon.defaultProps = {
  className: '',
  fill: '',
  width: '16px',
  height: '16px'
};

ExclamationIcon.propTypes = ICON_PROP_TYPES;

export const RoundExclamationIcon = props => {
  const { className, fill, width, height } = props;
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 22 22"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.0918 0.60437C5.32305 0.60437 0.691795 5.27624 0.691795 11.0044C0.691795 16.7731 5.32305 21.4044 11.0918 21.4044C16.8199 21.4044 21.4918 16.7731 21.4918 11.0044C21.4918 5.27624 16.8199 0.60437 11.0918 0.60437ZM10.1168 6.77937C10.1168 6.25124 10.523 5.80437 11.0918 5.80437C11.6199 5.80437 12.0668 6.25124 12.0668 6.77937V11.9794C12.0668 12.5481 11.6199 12.9544 11.0918 12.9544C10.523 12.9544 10.1168 12.5481 10.1168 11.9794V6.77937ZM11.0918 16.8544C10.3605 16.8544 9.79179 16.2856 9.79179 15.595C9.79179 14.9044 10.3605 14.3356 11.0918 14.3356C11.7824 14.3356 12.3512 14.9044 12.3512 15.595C12.3512 16.2856 11.7824 16.8544 11.0918 16.8544Z"
        fill={fill}
      />
    </svg>
  );
};

RoundExclamationIcon.defaultProps = {
  className: '',
  fill: '',
  width: '16px',
  height: '16px'
};

RoundExclamationIcon.propTypes = ICON_PROP_TYPES;

export const EyeIcon = props => {
  const { className, fill, width, height } = props;
  return (
    <svg
      className={className}
      width={width}
      height={height}
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 576 512"
    >
      <path
        fill={fill}
        d="M572.52 241.4C518.29 135.59 410.93 64 288 64S57.68 135.64 3.48 241.41a32.35 32.35 0 0 0 0 29.19C57.71 376.41 165.07 448 288 448s230.32-71.64 284.52-177.41a32.35 32.35 0 0 0 0-29.19zM288 400a144 144 0 1 1 144-144 143.93 143.93 0 0 1-144 144zm0-240a95.31 95.31 0 0 0-25.31 3.79 47.85 47.85 0 0 1-66.9 66.9A95.78 95.78 0 1 0 288 160z"
      />
    </svg>
  );
};

EyeIcon.defaultProps = {
  className: '',
  fill: '',
  width: '16px',
  height: '16px'
};

EyeIcon.propTypes = ICON_PROP_TYPES;

export const DownloadIcon = props => {
  const { className, fill, width, height } = props;
  return (
    <svg
      className={className}
      width={width}
      height={height}
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 640 512"
    >
      <path
        fill={fill}
        d="M537.6 226.6c4.1-10.7 6.4-22.4 6.4-34.6 0-53-43-96-96-96-19.7 0-38.1 6-53.3 16.2C367 64.2 315.3 32 256 32c-88.4 0-160 71.6-160 160 0 2.7.1 5.4.2 8.1C40.2 219.8 0 273.2 0 336c0 79.5 64.5 144 144 144h368c70.7 0 128-57.3 128-128 0-61.9-44-113.6-102.4-125.4zm-132.9 88.7L299.3 420.7c-6.2 6.2-16.4 6.2-22.6 0L171.3 315.3c-10.1-10.1-2.9-27.3 11.3-27.3H248V176c0-8.8 7.2-16 16-16h48c8.8 0 16 7.2 16 16v112h65.4c14.2 0 21.4 17.2 11.3 27.3z"
      />
    </svg>
  );
};

DownloadIcon.defaultProps = {
  className: '',
  fill: '',
  width: '16px',
  height: '16px'
};

DownloadIcon.propTypes = ICON_PROP_TYPES;

export const CalendarIcon = props => {
  const { className, fill, width, height } = props;
  return (
    <svg
      className={className}
      width={width}
      height={height}
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 448 512"
    >
      <path
        fill={fill}
        d="M0 464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V192H0v272zm320-196c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40zm0 128c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40zM192 268c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40zm0 128c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40zM64 268c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12H76c-6.6 0-12-5.4-12-12v-40zm0 128c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12H76c-6.6 0-12-5.4-12-12v-40zM400 64h-48V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v48H160V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v48H48C21.5 64 0 85.5 0 112v48h448v-48c0-26.5-21.5-48-48-48z"
      />
    </svg>
  );
};

CalendarIcon.defaultProps = {
  className: '',
  fill: '',
  width: '16px',
  height: '16px'
};

CalendarIcon.propTypes = ICON_PROP_TYPES;

export const MarkerIcon = props => {
  const { className, fill, width, height } = props;
  return (
    <svg
      className={className}
      width={width}
      height={height}
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 384 512"
    >
      <path
        fill={fill}
        d="M172.268 501.67C26.97 291.031 0 269.413 0 192 0 85.961 85.961 0 192 0s192 85.961 192 192c0 77.413-26.97 99.031-172.268 309.67-9.535 13.774-29.93 13.773-39.464 0zM192 272c44.183 0 80-35.817 80-80s-35.817-80-80-80-80 35.817-80 80 35.817 80 80 80z"
      />
    </svg>
  );
};

MarkerIcon.defaultProps = {
  className: '',
  fill: '',
  width: '16px',
  height: '16px'
};

MarkerIcon.propTypes = ICON_PROP_TYPES;

export const BuildingIcon = props => {
  const { className, fill, width, height } = props;
  return (
    <svg
      className={className}
      width={width}
      height={height}
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 448 512"
    >
      <path
        fill={fill}
        d="M436 480h-20V24c0-13.255-10.745-24-24-24H56C42.745 0 32 10.745 32 24v456H12c-6.627 0-12 5.373-12 12v20h448v-20c0-6.627-5.373-12-12-12zM128 76c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40c0 6.627-5.373 12-12 12h-40c-6.627 0-12-5.373-12-12V76zm0 96c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40c0 6.627-5.373 12-12 12h-40c-6.627 0-12-5.373-12-12v-40zm52 148h-40c-6.627 0-12-5.373-12-12v-40c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40c0 6.627-5.373 12-12 12zm76 160h-64v-84c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v84zm64-172c0 6.627-5.373 12-12 12h-40c-6.627 0-12-5.373-12-12v-40c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40zm0-96c0 6.627-5.373 12-12 12h-40c-6.627 0-12-5.373-12-12v-40c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40zm0-96c0 6.627-5.373 12-12 12h-40c-6.627 0-12-5.373-12-12V76c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40z"
      />
    </svg>
  );
};

BuildingIcon.defaultProps = {
  className: '',
  fill: '',
  width: '16px',
  height: '16px'
};

BuildingIcon.propTypes = ICON_PROP_TYPES;

export const AmazonIcon = props => {
  const { className, fill, width, height } = props;
  return (
    <svg
      width={width}
      height={height}
      className={className}
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 448 512"
    >
      <path
        fill={fill}
        d="M257.2 162.7c-48.7 1.8-169.5 15.5-169.5 117.5 0 109.5 138.3 114 183.5 43.2 6.5 10.2 35.4 37.5 45.3 46.8l56.8-56S341 288.9 341 261.4V114.3C341 89 316.5 32 228.7 32 140.7 32 94 87 94 136.3l73.5 6.8c16.3-49.5 54.2-49.5 54.2-49.5 40.7-.1 35.5 29.8 35.5 69.1zm0 86.8c0 80-84.2 68-84.2 17.2 0-47.2 50.5-56.7 84.2-57.8v40.6zm136 163.5c-7.7 10-70 67-174.5 67S34.2 408.5 9.7 379c-6.8-7.7 1-11.3 5.5-8.3C88.5 415.2 203 488.5 387.7 401c7.5-3.7 13.3 2 5.5 12zm39.8 2.2c-6.5 15.8-16 26.8-21.2 31-5.5 4.5-9.5 2.7-6.5-3.8s19.3-46.5 12.7-55c-6.5-8.3-37-4.3-48-3.2-10.8 1-13 2-14-.3-2.3-5.7 21.7-15.5 37.5-17.5 15.7-1.8 41-.8 46 5.7 3.7 5.1 0 27.1-6.5 43.1z"
      />
    </svg>
  );
};

AmazonIcon.defaultProps = {
  className: '',
  fill: '',
  width: '16px',
  height: '16px'
};

AmazonIcon.propTypes = ICON_PROP_TYPES;

export const PlayIcon = props => {
  const { className, fill, width, height } = props;
  return (
    <svg
      width={width}
      height={height}
      className={className}
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 448 512"
    >
      <path
        fill={fill}
        d="M424.4 214.7L72.4 6.6C43.8-10.3 0 6.1 0 47.9V464c0 37.5 40.7 60.1 72.4 41.3l352-208c31.4-18.5 31.5-64.1 0-82.6z"
      />
    </svg>
  );
};

PlayIcon.defaultProps = {
  className: '',
  fill: '',
  width: '16px',
  height: '16px'
};

PlayIcon.propTypes = ICON_PROP_TYPES;

export const ChartPieIcon = props => {
  const { className, fill, width, height } = props;
  return (
    <svg
      width={width}
      height={height}
      className={className}
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 544 512"
    >
      <path
        fill={fill}
        d="M527.79 288H290.5l158.03 158.03c6.04 6.04 15.98 6.53 22.19.68 38.7-36.46 65.32-85.61 73.13-140.86 1.34-9.46-6.51-17.85-16.06-17.85zm-15.83-64.8C503.72 103.74 408.26 8.28 288.8.04 279.68-.59 272 7.1 272 16.24V240h223.77c9.14 0 16.82-7.68 16.19-16.8zM224 288V50.71c0-9.55-8.39-17.4-17.84-16.06C86.99 51.49-4.1 155.6.14 280.37 4.5 408.51 114.83 513.59 243.03 511.98c50.4-.63 96.97-16.87 135.26-44.03 7.9-5.6 8.42-17.23 1.57-24.08L224 288z"
      />
    </svg>
  );
};

ChartPieIcon.defaultProps = {
  className: '',
  fill: '',
  width: '16px',
  height: '16px'
};

ChartPieIcon.propTypes = ICON_PROP_TYPES;

export const ChartLineIcon = props => {
  const { className, fill, width, height } = props;
  return (
    <svg
      width={width}
      height={height}
      className={className}
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 512 512"
    >
      <path
        fill={fill}
        d="M496 384H64V80c0-8.84-7.16-16-16-16H16C7.16 64 0 71.16 0 80v336c0 17.67 14.33 32 32 32h464c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zM464 96H345.94c-21.38 0-32.09 25.85-16.97 40.97l32.4 32.4L288 242.75l-73.37-73.37c-12.5-12.5-32.76-12.5-45.25 0l-68.69 68.69c-6.25 6.25-6.25 16.38 0 22.63l22.62 22.62c6.25 6.25 16.38 6.25 22.63 0L192 237.25l73.37 73.37c12.5 12.5 32.76 12.5 45.25 0l96-96 32.4 32.4c15.12 15.12 40.97 4.41 40.97-16.97V112c.01-8.84-7.15-16-15.99-16z"
      />
    </svg>
  );
};

ChartLineIcon.defaultProps = {
  className: '',
  fill: '',
  width: '16px',
  height: '16px'
};

ChartLineIcon.propTypes = ICON_PROP_TYPES;

export const UserSlashIcon = props => {
  const { className, fill, width, height } = props;
  return (
    <svg
      width={width}
      height={height}
      className={className}
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 640 512"
    >
      <path
        fill={fill}
        d="M633.8 458.1L362.3 248.3C412.1 230.7 448 183.8 448 128 448 57.3 390.7 0 320 0c-67.1 0-121.5 51.8-126.9 117.4L45.5 3.4C38.5-2 28.5-.8 23 6.2L3.4 31.4c-5.4 7-4.2 17 2.8 22.4l588.4 454.7c7 5.4 17 4.2 22.5-2.8l19.6-25.3c5.4-6.8 4.1-16.9-2.9-22.3zM96 422.4V464c0 26.5 21.5 48 48 48h350.2L207.4 290.3C144.2 301.3 96 356 96 422.4z"
      />
    </svg>
  );
};

UserSlashIcon.defaultProps = {
  className: '',
  fill: '',
  width: '16px',
  height: '16px'
};

UserSlashIcon.propTypes = ICON_PROP_TYPES;

export const HandPaperIcon = props => {
  const { className, fill, width, height } = props;
  return (
    <svg
      width={width}
      height={height}
      className={className}
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 448 512"
    >
      <path
        fill={fill}
        d="M408.781 128.007C386.356 127.578 368 146.36 368 168.79V256h-8V79.79c0-22.43-18.356-41.212-40.781-40.783C297.488 39.423 280 57.169 280 79v177h-8V40.79C272 18.36 253.644-.422 231.219.007 209.488.423 192 18.169 192 40v216h-8V80.79c0-22.43-18.356-41.212-40.781-40.783C121.488 40.423 104 58.169 104 80v235.992l-31.648-43.519c-12.993-17.866-38.009-21.817-55.877-8.823-17.865 12.994-21.815 38.01-8.822 55.877l125.601 172.705A48 48 0 0 0 172.073 512h197.59c22.274 0 41.622-15.324 46.724-37.006l26.508-112.66a192.011 192.011 0 0 0 5.104-43.975V168c.001-21.831-17.487-39.577-39.218-39.993z"
      />
    </svg>
  );
};

HandPaperIcon.defaultProps = {
  className: '',
  fill: '',
  width: '16px',
  height: '16px'
};

HandPaperIcon.propTypes = ICON_PROP_TYPES;

export const EnvelopeOpenIcon = props => {
  const { className, fill, width, height } = props;
  return (
    <svg
      width={width}
      height={height}
      className={className}
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 512 512"
    >
      <path
        fill={fill}
        d="M512 464c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V200.724a48 48 0 0 1 18.387-37.776c24.913-19.529 45.501-35.365 164.2-121.511C199.412 29.17 232.797-.347 256 .003c23.198-.354 56.596 29.172 73.413 41.433 118.687 86.137 139.303 101.995 164.2 121.512A48 48 0 0 1 512 200.724V464zm-65.666-196.605c-2.563-3.728-7.7-4.595-11.339-1.907-22.845 16.873-55.462 40.705-105.582 77.079-16.825 12.266-50.21 41.781-73.413 41.43-23.211.344-56.559-29.143-73.413-41.43-50.114-36.37-82.734-60.204-105.582-77.079-3.639-2.688-8.776-1.821-11.339 1.907l-9.072 13.196a7.998 7.998 0 0 0 1.839 10.967c22.887 16.899 55.454 40.69 105.303 76.868 20.274 14.781 56.524 47.813 92.264 47.573 35.724.242 71.961-32.771 92.263-47.573 49.85-36.179 82.418-59.97 105.303-76.868a7.998 7.998 0 0 0 1.839-10.967l-9.071-13.196z"
      />
    </svg>
  );
};

EnvelopeOpenIcon.defaultProps = {
  className: '',
  fill: '',
  width: '16px',
  height: '16px'
};

EnvelopeOpenIcon.propTypes = ICON_PROP_TYPES;

export const UserTagIcon = props => {
  const { className, fill, width, height } = props;
  return (
    <svg
      width={width}
      height={height}
      className={className}
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 640 512"
    >
      <path
        fill={fill}
        d="M630.6 364.9l-90.3-90.2c-12-12-28.3-18.7-45.3-18.7h-79.3c-17.7 0-32 14.3-32 32v79.2c0 17 6.7 33.2 18.7 45.2l90.3 90.2c12.5 12.5 32.8 12.5 45.3 0l92.5-92.5c12.6-12.5 12.6-32.7.1-45.2zm-182.8-21c-13.3 0-24-10.7-24-24s10.7-24 24-24 24 10.7 24 24c0 13.2-10.7 24-24 24zm-223.8-88c70.7 0 128-57.3 128-128C352 57.3 294.7 0 224 0S96 57.3 96 128c0 70.6 57.3 127.9 128 127.9zm127.8 111.2V294c-12.2-3.6-24.9-6.2-38.2-6.2h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 287.9 0 348.1 0 422.3v41.6c0 26.5 21.5 48 48 48h352c15.5 0 29.1-7.5 37.9-18.9l-58-58c-18.1-18.1-28.1-42.2-28.1-67.9z"
      />
    </svg>
  );
};

UserTagIcon.defaultProps = {
  className: '',
  fill: '',
  width: '16px',
  height: '16px'
};

UserTagIcon.propTypes = ICON_PROP_TYPES;

export const TrashIcon = props => {
  const { className, fill, width, height } = props;
  return (
    <svg
      width={width}
      height={height}
      className={className}
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 448 512"
    >
      <path
        fill={fill}
        d="M432 32H312l-9.4-18.7A24 24 0 0 0 281.1 0H166.8a23.72 23.72 0 0 0-21.4 13.3L136 32H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zM53.2 467a48 48 0 0 0 47.9 45h245.8a48 48 0 0 0 47.9-45L416 128H32z"
      />
    </svg>
  );
};

TrashIcon.defaultProps = {
  className: '',
  fill: '',
  width: '16px',
  height: '16px'
};

TrashIcon.propTypes = ICON_PROP_TYPES;

export const CopyIcon = props => {
  const { className, fill, width, height } = props;
  return (
    <svg
      width={width}
      height={height}
      className={className}
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 448 512"
    >
      <path
        fill={fill}
        d="M320 448v40c0 13.255-10.745 24-24 24H24c-13.255 0-24-10.745-24-24V120c0-13.255 10.745-24 24-24h72v296c0 30.879 25.121 56 56 56h168zm0-344V0H152c-13.255 0-24 10.745-24 24v368c0 13.255 10.745 24 24 24h272c13.255 0 24-10.745 24-24V128H344c-13.2 0-24-10.8-24-24zm120.971-31.029L375.029 7.029A24 24 0 0 0 358.059 0H352v96h96v-6.059a24 24 0 0 0-7.029-16.97z"
      />
    </svg>
  );
};

CopyIcon.defaultProps = {
  className: '',
  fill: '',
  width: '16px',
  height: '16px'
};

CopyIcon.propTypes = ICON_PROP_TYPES;

export const MousePointerIcon = props => {
  const { className, fill, width, height } = props;
  return (
    <svg
      width={width}
      height={height}
      className={className}
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 320 512"
    >
      <path
        fill={fill}
        d="M302.189 329.126H196.105l55.831 135.993c3.889 9.428-.555 19.999-9.444 23.999l-49.165 21.427c-9.165 4-19.443-.571-23.332-9.714l-53.053-129.136-86.664 89.138C18.729 472.71 0 463.554 0 447.977V18.299C0 1.899 19.921-6.096 30.277 5.443l284.412 292.542c11.472 11.179 3.007 31.141-12.5 31.141z"
      />
    </svg>
  );
};

MousePointerIcon.defaultProps = {
  className: '',
  fill: '',
  width: '16px',
  height: '16px'
};

MousePointerIcon.propTypes = ICON_PROP_TYPES;

export const EllipsisIcon = props => {
  const { className, fill, width, height } = props;
  return (
    <svg
      width={width}
      height={height}
      className={className}
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 192 512"
    >
      <path
        fill={fill}
        d="M96 184c39.8 0 72 32.2 72 72s-32.2 72-72 72-72-32.2-72-72 32.2-72 72-72zM24 80c0 39.8 32.2 72 72 72s72-32.2 72-72S135.8 8 96 8 24 40.2 24 80zm0 352c0 39.8 32.2 72 72 72s72-32.2 72-72-32.2-72-72-72-72 32.2-72 72z"
      />
    </svg>
  );
};

EllipsisIcon.defaultProps = {
  className: '',
  fill: '',
  width: '16px',
  height: '16px'
};

EllipsisIcon.propTypes = ICON_PROP_TYPES;

export const PaperPlaneIcon = props => {
  const { className, fill, width, height } = props;
  return (
    <svg
      width={width}
      height={height}
      className={className}
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 512 512"
    >
      <path
        fill={fill}
        d="M476 3.2L12.5 270.6c-18.1 10.4-15.8 35.6 2.2 43.2L121 358.4l287.3-253.2c5.5-4.9 13.3 2.6 8.6 8.3L176 407v80.5c0 23.6 28.5 32.9 42.5 15.8L282 426l124.6 52.2c14.2 6 30.4-2.9 33-18.2l72-432C515 7.8 493.3-6.8 476 3.2z"
      />
    </svg>
  );
};

PaperPlaneIcon.defaultProps = {
  className: '',
  fill: '',
  width: '16px',
  height: '16px'
};

PaperPlaneIcon.propTypes = ICON_PROP_TYPES;

export const CogIcon = props => {
  const { className, fill, width, height } = props;
  return (
    <svg
      width={width}
      height={height}
      className={className}
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 512 512"
    >
      <path
        fill={fill}
        d="M487.4 315.7l-42.6-24.6c4.3-23.2 4.3-47 0-70.2l42.6-24.6c4.9-2.8 7.1-8.6 5.5-14-11.1-35.6-30-67.8-54.7-94.6-3.8-4.1-10-5.1-14.8-2.3L380.8 110c-17.9-15.4-38.5-27.3-60.8-35.1V25.8c0-5.6-3.9-10.5-9.4-11.7-36.7-8.2-74.3-7.8-109.2 0-5.5 1.2-9.4 6.1-9.4 11.7V75c-22.2 7.9-42.8 19.8-60.8 35.1L88.7 85.5c-4.9-2.8-11-1.9-14.8 2.3-24.7 26.7-43.6 58.9-54.7 94.6-1.7 5.4.6 11.2 5.5 14L67.3 221c-4.3 23.2-4.3 47 0 70.2l-42.6 24.6c-4.9 2.8-7.1 8.6-5.5 14 11.1 35.6 30 67.8 54.7 94.6 3.8 4.1 10 5.1 14.8 2.3l42.6-24.6c17.9 15.4 38.5 27.3 60.8 35.1v49.2c0 5.6 3.9 10.5 9.4 11.7 36.7 8.2 74.3 7.8 109.2 0 5.5-1.2 9.4-6.1 9.4-11.7v-49.2c22.2-7.9 42.8-19.8 60.8-35.1l42.6 24.6c4.9 2.8 11 1.9 14.8-2.3 24.7-26.7 43.6-58.9 54.7-94.6 1.5-5.5-.7-11.3-5.6-14.1zM256 336c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80z"
      />
    </svg>
  );
};

CogIcon.defaultProps = {
  className: '',
  fill: '',
  width: '16px',
  height: '16px'
};

CogIcon.propTypes = ICON_PROP_TYPES;

export const StarIcon = props => {
  const { className, fill, width, height } = props;
  return (
    <svg
      width={width}
      height={height}
      className={className}
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 576 512"
    >
      <path
        fill={fill}
        d="M259.3 17.8L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z"
      />
    </svg>
  );
};

StarIcon.defaultProps = {
  className: '',
  fill: '',
  width: '16px',
  height: '16px'
};

StarIcon.propTypes = ICON_PROP_TYPES;

export const ArrowIcon = props => {
  const { className, fill, width, height } = props;
  return (
    <svg
      width={width}
      height={height}
      className={className}
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 448 512"
    >
      <path
        fill={fill}
        d="M257.5 445.1l-22.2 22.2c-9.4 9.4-24.6 9.4-33.9 0L7 273c-9.4-9.4-9.4-24.6 0-33.9L201.4 44.7c9.4-9.4 24.6-9.4 33.9 0l22.2 22.2c9.5 9.5 9.3 25-.4 34.3L136.6 216H424c13.3 0 24 10.7 24 24v32c0 13.3-10.7 24-24 24H136.6l120.5 114.8c9.8 9.3 10 24.8.4 34.3z"
      />
    </svg>
  );
};

ArrowIcon.defaultProps = {
  className: '',
  fill: '',
  width: '16px',
  height: '16px'
};

ArrowIcon.propTypes = ICON_PROP_TYPES;

export const StickArrowIcon = props => {
  const { className, fill, width, height, rotated } = props;
  const imgStyle = rotated ? { transform: 'rotate(-180deg)' } : {};
  return (
    <svg
      width={width}
      height={height}
      style={imgStyle}
      className={className}
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 8 10"
    >
      <path
        d="M0.134762 4.52978L3.54726 0.954779C3.64882 0.853217 3.7707 0.812592 3.91289 0.812592C4.03476 0.812592 4.15664 0.853217 4.2582 0.954779L7.6707 4.52978C7.85351 4.7329 7.85351 5.03759 7.65039 5.2204C7.46757 5.40322 7.14257 5.40322 6.95976 5.20009L4.40039 2.49853V9.40478C4.40039 9.68915 4.17695 9.89228 3.91289 9.89228C3.66914 9.89228 3.42539 9.68915 3.42539 9.40478V2.49853L0.8457 5.20009C0.662887 5.40322 0.337887 5.40322 0.155075 5.2204C-0.0480504 5.03759 -0.0480504 4.71259 0.134762 4.52978Z"
        fill={fill}
      />
    </svg>
  );
};

StickArrowIcon.defaultProps = {
  className: '',
  fill: '',
  width: '8px',
  height: '10px',
  rotated: false
};

StickArrowIcon.propTypes = {
  className: PropTypes.string,
  fill: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
  rotated: PropTypes.bool
};

export const CircleIcon = props => {
  const { className, fill, width, height } = props;
  return (
    <svg
      width={width}
      height={height}
      className={className}
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 512 512"
    >
      <path fill={fill} d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8z" />
    </svg>
  );
};

CircleIcon.defaultProps = {
  className: '',
  fill: '',
  width: '16px',
  height: '16px'
};

CircleIcon.propTypes = ICON_PROP_TYPES;

export const InfinityIcon = props => {
  const { className, fill, width, height } = props;
  return (
    <svg
      width={width}
      height={height}
      className={className}
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 477.867 477.867"
    >
      <path
        fill={fill}
        d="M375.467,136.533c-53.333,0-110.933,51.661-136.533,77.534c-25.6-25.873-83.2-77.534-136.533-77.534
			c-64.119,0-102.4,38.281-102.4,102.4s38.281,102.4,102.4,102.4c53.333,0,110.933-51.661,136.533-77.534
			c25.6,25.873,83.2,77.534,136.533,77.534c64.12,0,102.4-38.281,102.4-102.4S439.586,136.533,375.467,136.533z M102.4,307.2
			c-45.295,0-68.267-22.972-68.267-68.267s22.972-68.267,68.267-68.267c37.547,0,87.381,42.308,113.118,68.267
			C189.833,264.926,140.1,307.2,102.4,307.2z M375.467,307.2c-37.547,0-87.381-42.308-113.118-68.267
			c25.6-25.975,75.418-68.267,113.118-68.267c45.295,0,68.267,22.972,68.267,68.267S420.762,307.2,375.467,307.2z"
      />
    </svg>
  );
};

InfinityIcon.defaultProps = {
  className: '',
  fill: '',
  width: '16px',
  height: '16px'
};

InfinityIcon.propTypes = ICON_PROP_TYPES;

export const EdgeStarIcon = props => {
  const { className, fill, width, height } = props;
  return (
    <svg
      width={width}
      height={height}
      className={className}
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
    >
      <path
        fill={fill}
        d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"
      />
    </svg>
  );
};

EdgeStarIcon.defaultProps = {
  className: '',
  fill: '',
  width: '16px',
  height: '16px'
};

EdgeStarIcon.propTypes = ICON_PROP_TYPES;

export const DotCircleIcon = props => {
  const { className, fill, width, height } = props;
  return (
    <svg
      width={width}
      height={height}
      className={className}
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 408.221 408.221"
    >
      <path
        fill={fill}
        d="M204.11,0C91.388,0,0,91.388,0,204.111c0,112.725,91.388,204.11,204.11,204.11c112.729,0,204.11-91.385,204.11-204.11
			C408.221,91.388,316.839,0,204.11,0z M204.11,303.711c-54.817,0-99.26-44.434-99.26-99.248c0-54.817,44.442-99.259,99.26-99.259
			c54.813,0,99.264,44.442,99.264,99.259C303.374,259.277,258.924,303.711,204.11,303.711z"
      />
    </svg>
  );
};

DotCircleIcon.defaultProps = {
  className: '',
  fill: '',
  width: '16px',
  height: '16px'
};

DotCircleIcon.propTypes = ICON_PROP_TYPES;

export const ClipIcon = props => {
  const { className, fill, width, height } = props;
  return (
    <svg
      width={width}
      height={height}
      className={className}
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 448 512"
    >
      <path
        fill={fill}
        d="M43.246 466.142c-58.43-60.289-57.341-157.511 1.386-217.581L254.392 34c44.316-45.332 116.351-45.336 160.671 0 43.89 44.894 43.943 117.329 0 162.276L232.214 383.128c-29.855 30.537-78.633 30.111-107.982-.998-28.275-29.97-27.368-77.473 1.452-106.953l143.743-146.835c6.182-6.314 16.312-6.422 22.626-.241l22.861 22.379c6.315 6.182 6.422 16.312.241 22.626L171.427 319.927c-4.932 5.045-5.236 13.428-.648 18.292 4.372 4.634 11.245 4.711 15.688.165l182.849-186.851c19.613-20.062 19.613-52.725-.011-72.798-19.189-19.627-49.957-19.637-69.154 0L90.39 293.295c-34.763 35.56-35.299 93.12-1.191 128.313 34.01 35.093 88.985 35.137 123.058.286l172.06-175.999c6.177-6.319 16.307-6.433 22.626-.256l22.877 22.364c6.319 6.177 6.434 16.307.256 22.626l-172.06 175.998c-59.576 60.938-155.943 60.216-214.77-.485z"
      />
    </svg>
  );
};

ClipIcon.defaultProps = {
  className: '',
  fill: '',
  width: '16px',
  height: '16px'
};

ClipIcon.propTypes = ICON_PROP_TYPES;

export const HistoryIcon = props => {
  const { className, fill, width, height } = props;
  return (
    <svg
      width={width}
      height={height}
      className={className}
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 512 512"
    >
      <path
        fill={fill}
        d="M504 255.531c.253 136.64-111.18 248.372-247.82 248.468-59.015.042-113.223-20.53-155.822-54.911-11.077-8.94-11.905-25.541-1.839-35.607l11.267-11.267c8.609-8.609 22.353-9.551 31.891-1.984C173.062 425.135 212.781 440 256 440c101.705 0 184-82.311 184-184 0-101.705-82.311-184-184-184-48.814 0-93.149 18.969-126.068 49.932l50.754 50.754c10.08 10.08 2.941 27.314-11.313 27.314H24c-8.837 0-16-7.163-16-16V38.627c0-14.254 17.234-21.393 27.314-11.314l49.372 49.372C129.209 34.136 189.552 8 256 8c136.81 0 247.747 110.78 248 247.531zm-180.912 78.784l9.823-12.63c8.138-10.463 6.253-25.542-4.21-33.679L288 256.349V152c0-13.255-10.745-24-24-24h-16c-13.255 0-24 10.745-24 24v135.651l65.409 50.874c10.463 8.137 25.541 6.253 33.679-4.21z"
      />
    </svg>
  );
};

HistoryIcon.defaultProps = {
  className: '',
  fill: '',
  width: '16px',
  height: '16px'
};

HistoryIcon.propTypes = ICON_PROP_TYPES;

export const BookmarkIcon = props => {
  const { className, fill, width, height } = props;
  return (
    <svg
      width={width}
      height={height}
      className={className}
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 384 512"
    >
      <path
        fill={fill}
        d="M0 512V48C0 21.49 21.49 0 48 0h288c26.51 0 48 21.49 48 48v464L192 400 0 512z"
      />
    </svg>
  );
};

BookmarkIcon.defaultProps = {
  className: '',
  fill: '',
  width: '16px',
  height: '16px'
};

BookmarkIcon.propTypes = ICON_PROP_TYPES;

export const PercentIcon = props => {
  const { className, fill, width, height } = props;
  return (
    <svg
      width={width}
      height={height}
      className={className}
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 448 512"
    >
      <path
        fill={fill}
        d="M112 224c61.9 0 112-50.1 112-112S173.9 0 112 0 0 50.1 0 112s50.1 112 112 112zm0-160c26.5 0 48 21.5 48 48s-21.5 48-48 48-48-21.5-48-48 21.5-48 48-48zm224 224c-61.9 0-112 50.1-112 112s50.1 112 112 112 112-50.1 112-112-50.1-112-112-112zm0 160c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zM392.3.2l31.6-.1c19.4-.1 30.9 21.8 19.7 37.8L77.4 501.6a23.95 23.95 0 0 1-19.6 10.2l-33.4.1c-19.5 0-30.9-21.9-19.7-37.8l368-463.7C377.2 4 384.5.2 392.3.2z"
      />
    </svg>
  );
};

PercentIcon.defaultProps = {
  className: '',
  fill: '',
  width: '16px',
  height: '16px'
};

PercentIcon.propTypes = ICON_PROP_TYPES;

export const ExternalLinkIcon = props => {
  const { className, fill, width, height } = props;
  return (
    <svg
      width={width}
      height={height}
      className={className}
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 448 512"
    >
      <path
        fill={fill}
        d="M448 80v352c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V80c0-26.51 21.49-48 48-48h352c26.51 0 48 21.49 48 48zm-88 16H248.029c-21.313 0-32.08 25.861-16.971 40.971l31.984 31.987L67.515 364.485c-4.686 4.686-4.686 12.284 0 16.971l31.029 31.029c4.687 4.686 12.285 4.686 16.971 0l195.526-195.526 31.988 31.991C358.058 263.977 384 253.425 384 231.979V120c0-13.255-10.745-24-24-24z"
      />
    </svg>
  );
};

ExternalLinkIcon.defaultProps = {
  className: '',
  fill: '',
  width: '16px',
  height: '16px'
};

ExternalLinkIcon.propTypes = ICON_PROP_TYPES;

export const ExcelIcon = props => {
  const { className, fill, width, height } = props;
  return (
    <svg
      width={width}
      height={height}
      className={className}
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 448 512"
    >
      <path
        fill={fill}
        d="M369.9 97.9L286 14C277 5 264.8-.1 252.1-.1H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V131.9c0-12.7-5.1-25-14.1-34zM332.1 128H256V51.9l76.1 76.1zM48 464V48h160v104c0 13.3 10.7 24 24 24h104v288H48zm212-240h-28.8c-4.4 0-8.4 2.4-10.5 6.3-18 33.1-22.2 42.4-28.6 57.7-13.9-29.1-6.9-17.3-28.6-57.7-2.1-3.9-6.2-6.3-10.6-6.3H124c-9.3 0-15 10-10.4 18l46.3 78-46.3 78c-4.7 8 1.1 18 10.4 18h28.9c4.4 0 8.4-2.4 10.5-6.3 21.7-40 23-45 28.6-57.7 14.9 30.2 5.9 15.9 28.6 57.7 2.1 3.9 6.2 6.3 10.6 6.3H260c9.3 0 15-10 10.4-18L224 320c.7-1.1 30.3-50.5 46.3-78 4.7-8-1.1-18-10.3-18z"
      />
    </svg>
  );
};

ExcelIcon.defaultProps = {
  className: '',
  fill: '',
  width: '16px',
  height: '16px'
};

ExcelIcon.propTypes = ICON_PROP_TYPES;

export const SyncIcon = props => {
  const { className, fill, width, height } = props;
  return (
    <svg
      width={width}
      height={height}
      className={className}
      viewBox="0 0 100 100"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <g transform="translate(0.000000, 8.000000)" stroke={fill} strokeWidth="8">
          <path
            d="M89,40 C89,17.90861 71.09139,0 49,0 C34.1239759,0 21.1446258,8.12062657 14.2530697,20.1707596"
            id="Layer-1"
          />
          <polyline
            id="Layer-2"
            transform="translate(89.000000, 37.000000) scale(1, -1) rotate(11.000000) translate(-89.000000, -37.000000) "
            points="79 42 89 32 99 42"
          />
          <path
            d="M91,84 C91,61.90861 73.09139,44 51,44 C36.1239759,44 23.1446258,52.1206266 16.2530697,64.1707596"
            id="Layer-3"
            transform="translate(51.000000, 64.000000) scale(-1, -1) translate(-51.000000, -64.000000) "
          />
          <polyline
            id="Layer-4"
            transform="translate(11.000000, 47.000000) scale(-1, 1) rotate(11.000000) translate(-11.000000, -47.000000) "
            points="1 52 11 42 21 52"
          />
        </g>
      </g>
    </svg>
  );
};

SyncIcon.defaultProps = {
  className: '',
  fill: '',
  width: '16px',
  height: '16px'
};

SyncIcon.propTypes = ICON_PROP_TYPES;

export const CameraIcon = props => {
  const { className, fill, width, height } = props;
  return (
    <svg
      width={width}
      height={height}
      className={className}
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 512 512"
    >
      <path
        fill={fill}
        d="M512 144v288c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V144c0-26.5 21.5-48 48-48h88l12.3-32.9c7-18.7 24.9-31.1 44.9-31.1h125.5c20 0 37.9 12.4 44.9 31.1L376 96h88c26.5 0 48 21.5 48 48zM376 288c0-66.2-53.8-120-120-120s-120 53.8-120 120 53.8 120 120 120 120-53.8 120-120zm-32 0c0 48.5-39.5 88-88 88s-88-39.5-88-88 39.5-88 88-88 88 39.5 88 88z"
      />
    </svg>
  );
};

CameraIcon.defaultProps = {
  className: '',
  fill: '',
  width: '16px',
  height: '16px'
};

CameraIcon.propTypes = ICON_PROP_TYPES;

export const WarehouseIcon = props => {
  const { className, fill, width, height } = props;
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 19 16"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        opacity="0.981087"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.77273 0V1.75111L13.8182 6.19556V7.11111H15.5455V8.88889H13.8182V10.6667H15.5455V12.4444H13.8182V16H19V0H7.77273ZM15.5455 5.33333H13.8182V3.55556H15.5455V5.33333ZM0 16V7.11111L6.04545 2.66667L12.0909 7.11111V16H7.77273V10.6667H4.31818V16H0Z"
        fill={fill}
      />
    </svg>
  );
};

WarehouseIcon.defaultProps = {
  className: '',
  fill: '',
  width: '19px',
  height: '16px'
};

WarehouseIcon.propTypes = ICON_PROP_TYPES;

export const SoftwareIcon = props => {
  const { className, fill, width, height } = props;
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 15"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        opacity="0.981087"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.16667 8.33333H0.5V0H7.16667V8.33333ZM7.16667 15H0.5V10H7.16667V15ZM8.83333 15H15.5V6.66667H8.83333V15ZM8.83333 5V0H15.5V5H8.83333Z"
        fill={fill}
      />
    </svg>
  );
};

SoftwareIcon.defaultProps = {
  className: '',
  fill: '',
  width: '16px',
  height: '15px'
};

SoftwareIcon.propTypes = ICON_PROP_TYPES;

export const OrderIcon = props => {
  const { className, fill, width, height } = props;
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 18 16"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        opacity="0.981087"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.3552 0.488889L16.7858 2.61283C17.0129 2.87901 17.0058 3.50757 17.0009 3.9452C17.0002 4.00446 16.9996 4.06022 16.9996 4.11111V14.2222C16.9996 15.2 16.1996 16 15.2218 16H2.7774C1.79962 16 0.999621 15.2 0.999621 14.2222V4.11111C0.999621 4.02838 0.996136 3.93277 0.992396 3.83017C0.97685 3.40365 0.956905 2.85646 1.1647 2.61283L2.63518 0.488889C2.88407 0.186667 3.24851 0 3.66629 0H14.333C14.7507 0 15.1152 0.186667 15.3552 0.488889ZM3.60687 0.675425L1.88407 2.77778H16.1063L14.2735 0.675425H3.60687Z"
        fill={fill}
      />
    </svg>
  );
};

OrderIcon.defaultProps = {
  className: '',
  fill: '',
  width: '18px',
  height: '16px'
};

OrderIcon.propTypes = ICON_PROP_TYPES;

export const TaxIcon = props => {
  const { className, fill, width, height } = props;
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 15"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        opacity="0.981087"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.3636 1.875C16.3636 0.84375 15.5455 0 14.5455 0H1.81818C0.818182 0 0 0.84375 0 1.875V9.375C0 10.4062 0.818182 11.25 1.81818 11.25H14.5455C15.5455 11.25 16.3636 10.4062 16.3636 9.375V1.875ZM8.18182 8.4375C6.67273 8.4375 5.45455 7.18125 5.45455 5.625C5.45455 4.06875 6.67273 2.8125 8.18182 2.8125C9.69091 2.8125 10.9091 4.06875 10.9091 5.625C10.9091 7.18125 9.69091 8.4375 8.18182 8.4375ZM20 13.125V2.8125H18.1818V13.125H2.72727V15H18.1818C19.1818 15 20 14.1562 20 13.125Z"
        fill={fill}
      />
    </svg>
  );
};

TaxIcon.defaultProps = {
  className: '',
  fill: '',
  width: '20px',
  height: '15px'
};

TaxIcon.propTypes = ICON_PROP_TYPES;

export const ArrowRightIcon = props => {
  const { className, fill, width, height } = props;
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 11 9"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M5.95312 2.13281L7.5 3.65625H0.5625C0.234375 3.65625 0 3.91406 0 4.21875V4.78125C0 5.10938 0.234375 5.34375 0.5625 5.34375H7.5L5.95312 6.89062C5.74219 7.10156 5.74219 7.47656 5.95312 7.6875L6.35156 8.08594C6.5625 8.29688 6.9375 8.29688 7.14844 8.08594L10.3125 4.89844C10.5469 4.6875 10.5469 4.33594 10.3125 4.125L7.14844 0.9375C6.9375 0.726562 6.5625 0.726562 6.35156 0.9375L5.95312 1.33594C5.74219 1.54688 5.74219 1.92188 5.95312 2.13281Z"
        fill={fill}
      />
    </svg>
  );
};

ArrowRightIcon.defaultProps = {
  className: '',
  fill: '',
  width: '11px',
  height: '9px'
};

ArrowRightIcon.propTypes = ICON_PROP_TYPES;

export const InfoIcon = props => {
  const { className, fill, width, height } = props;
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 512 512"
      width={width}
      height={height}
    >
      <path
        d="M256 8C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8zm0 110c23.196 0 42 18.804 42 42s-18.804 42-42 42-42-18.804-42-42 18.804-42 42-42zm56 254c0 6.627-5.373 12-12 12h-88c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h12v-64h-12c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h64c6.627 0 12 5.373 12 12v100h12c6.627 0 12 5.373 12 12v24z"
        fill={fill}
      />
    </svg>
  );
};

InfoIcon.defaultProps = {
  className: '',
  fill: '',
  width: '16px',
  height: '16px'
};

InfoIcon.propTypes = ICON_PROP_TYPES;

export const FitInIcon = props => {
  const { className, fill, width, height } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 -960 960 960"
      className={className}
      width={width}
      height={height}
    >
      <path
        fill={fill}
        d="M800-600v-120H680v-80h120q33 0 56.5 23.5T880-720v120h-80Zm-720 0v-120q0-33 23.5-56.5T160-800h120v80H160v120H80Zm600 440v-80h120v-120h80v120q0 33-23.5 56.5T800-160H680Zm-520 0q-33 0-56.5-23.5T80-240v-120h80v120h120v80H160Zm80-160v-320h480v320H240Zm80-80h320v-160H320v160Zm0 0v-160 160Z"
      />
    </svg>
  );
};

FitInIcon.defaultProps = {
  className: '',
  fill: '',
  width: '16px',
  height: '16px'
};

FitInIcon.propTypes = ICON_PROP_TYPES;

export const PlusIcon = props => {
  const { className, fill, width, height } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 512 512"
      className={className}
      width={width}
      height={height}
      fill={fill}
    >
      <g>
        <g>
          <path
            d="M491.841,156.427c-19.471-45.946-51.936-85.013-92.786-112.637C358.217,16.166,308.893-0.007,256,0
			c-35.254-0.002-68.946,7.18-99.571,20.158C110.484,39.63,71.416,72.093,43.791,112.943C16.167,153.779-0.007,203.104,0,256
			c-0.002,35.255,7.181,68.948,20.159,99.573c19.471,45.946,51.937,85.013,92.786,112.637C153.783,495.834,203.107,512.007,256,512
			c35.253,0.002,68.946-7.18,99.571-20.158c45.945-19.471,85.013-51.935,112.638-92.785C495.834,358.22,512.007,308.894,512,256
			C512.002,220.744,504.819,187.052,491.841,156.427z M460.413,342.257c-16.851,39.781-45.045,73.723-80.476,97.676
			c-35.443,23.953-78.02,37.926-123.936,37.933c-30.619-0.002-59.729-6.218-86.255-17.454
			c-39.781-16.851-73.724-45.044-97.677-80.475C48.114,344.495,34.14,301.917,34.133,256c0.002-30.62,6.219-59.731,17.454-86.257
			c16.851-39.781,45.045-73.724,80.476-97.676C167.506,48.113,210.084,34.14,256,34.133c30.619,0.002,59.729,6.218,86.255,17.454
			c39.781,16.85,73.724,45.044,97.677,80.475c23.953,35.443,37.927,78.02,37.934,123.939
			C477.864,286.62,471.648,315.731,460.413,342.257z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M389.594,239.301H272.699V122.406c0-9.222-7.477-16.699-16.699-16.699c-9.222,0-16.699,7.477-16.699,16.699v116.895
			H122.406c-9.222,0-16.699,7.477-16.699,16.699s7.477,16.699,16.699,16.699h116.895v116.895c0,9.222,7.477,16.699,16.699,16.699
			c9.222,0,16.699-7.477,16.699-16.699V272.699h116.895c9.222,0,16.699-7.477,16.699-16.699S398.817,239.301,389.594,239.301z"
          />
        </g>
      </g>
    </svg>
  );
};

PlusIcon.defaultProps = {
  className: '',
  fill: '',
  width: '16px',
  height: '16px'
};

PlusIcon.propTypes = ICON_PROP_TYPES;

export const TrendArrowIcon = props => {
  const { className, fill, width, height, mirror } = props;
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ transform: mirror ? 'scaleY(-1)' : '' }}
    >
      <g clipPath="url(#clip0_1456_15334)">
        <path
          d="M2.41663 10.4167L5.91663 6.91667L8.24996 9.25001L12.9166 4.58334"
          stroke={fill}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.9166 8.66667V4.58334H8.83325"
          stroke={fill}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_1456_15334">
          <rect width="14" height="14" fill={fill} transform="matrix(1 0 0 -1 0.666626 14.5)" />
        </clipPath>
      </defs>
    </svg>
  );
};

TrendArrowIcon.propTypes = {
  className: PropTypes.string,
  fill: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
  mirror: PropTypes.bool
};

TrendArrowIcon.defaultProps = {
  className: '',
  fill: 'white',
  width: '15px',
  height: '15px',
  mirror: false
};

export const SadSmileIcon = props => {
  const { className, fill, width, height } = props;
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.8334 1.89667C19.593 2.91267 21.0568 4.37062 22.0798 6.12619C23.1028 7.88176 23.6496 9.87407 23.666 11.9059C23.6825 13.9377 23.1679 15.9386 22.1734 17.7105C21.1789 19.4824 19.7388 20.9638 17.9958 22.008C16.2528 23.0523 14.2673 23.6233 12.2358 23.6644C10.2043 23.7055 8.19735 23.2154 6.41352 22.2425C4.62969 21.2695 3.13089 19.8476 2.06549 18.1174C1.00008 16.3873 0.405018 14.4088 0.339207 12.378L0.333374 12L0.339207 11.622C0.404544 9.60716 0.990846 7.64363 2.04095 5.92283C3.09106 4.20204 4.56914 2.7827 6.33108 1.8032C8.09303 0.823705 10.0787 0.31747 12.0945 0.333851C14.1104 0.350232 16.0876 0.888671 17.8334 1.89667ZM12 13.4C11.3017 13.4 10.6104 13.5392 9.9665 13.8097C9.32265 14.0801 8.73922 14.4763 8.25037 14.975C8.14057 15.0839 8.05349 15.2134 7.99421 15.3562C7.93493 15.499 7.90462 15.6522 7.90505 15.8068C7.90547 15.9614 7.93663 16.1144 7.9967 16.2568C8.05677 16.3993 8.14455 16.5284 8.25496 16.6367C8.36536 16.7449 8.49618 16.8301 8.6398 16.8873C8.78343 16.9446 8.937 16.9727 9.09159 16.9701C9.24618 16.9674 9.3987 16.9341 9.54029 16.872C9.68189 16.8099 9.80972 16.7203 9.91637 16.6083C10.188 16.3311 10.5121 16.1108 10.8699 15.9604C11.2277 15.81 11.6119 15.7326 12 15.7326C12.3882 15.7326 12.7724 15.81 13.1302 15.9604C13.4879 16.1108 13.8121 16.3311 14.0837 16.6083C14.3014 16.8241 14.5953 16.9456 14.9018 16.9464C15.2084 16.9473 15.5029 16.8275 15.7218 16.6129C15.9407 16.3983 16.0663 16.1061 16.0715 15.7997C16.0768 15.4932 15.9612 15.1969 15.7497 14.975C15.2609 14.4763 14.6774 14.0801 14.0336 13.8097C13.3897 13.5392 12.6984 13.4 12 13.4ZM8.51171 8.50001L8.36354 8.50817C8.07998 8.5419 7.81864 8.67846 7.62902 8.89197C7.4394 9.10548 7.33467 9.38112 7.33467 9.66667C7.33467 9.95223 7.4394 10.2279 7.62902 10.4414C7.81864 10.6549 8.07998 10.7914 8.36354 10.8252L8.50004 10.8333L8.64821 10.8252C8.93176 10.7914 9.19311 10.6549 9.38273 10.4414C9.57234 10.2279 9.67707 9.95223 9.67707 9.66667C9.67707 9.38112 9.57234 9.10548 9.38273 8.89197C9.19311 8.67846 8.93176 8.5419 8.64821 8.50817L8.51171 8.50001ZM15.5117 8.50001L15.3635 8.50817C15.08 8.5419 14.8186 8.67846 14.629 8.89197C14.4394 9.10548 14.3347 9.38112 14.3347 9.66667C14.3347 9.95223 14.4394 10.2279 14.629 10.4414C14.8186 10.6549 15.08 10.7914 15.3635 10.8252L15.5 10.8333L15.6482 10.8252C15.9318 10.7914 16.1931 10.6549 16.3827 10.4414C16.5723 10.2279 16.6771 9.95223 16.6771 9.66667C16.6771 9.38112 16.5723 9.10548 16.3827 8.89197C16.1931 8.67846 15.9318 8.5419 15.6482 8.50817L15.5117 8.50001Z"
        fill={fill}
      />
    </svg>
  );
};

SadSmileIcon.propTypes = {
  className: PropTypes.string,
  fill: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string
};

SadSmileIcon.defaultProps = {
  className: '',
  fill: '#B1B1B1',
  width: '24px',
  height: '24px'
};

export const HappySmileIcon = props => {
  const { className, fill, width, height } = props;
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.8334 1.89664C19.593 2.91264 21.0568 4.37059 22.0798 6.12616C23.1028 7.88173 23.6496 9.87404 23.666 11.9059C23.6825 13.9377 23.1679 15.9386 22.1734 17.7105C21.1789 19.4823 19.7388 20.9637 17.9958 22.008C16.2528 23.0523 14.2673 23.6233 12.2358 23.6644C10.2043 23.7055 8.19735 23.2153 6.41352 22.2424C4.62969 21.2695 3.13089 19.8476 2.06549 18.1174C1.00008 16.3872 0.405018 14.4088 0.339207 12.378L0.333374 12L0.339207 11.622C0.404544 9.60713 0.990846 7.6436 2.04095 5.9228C3.09106 4.202 4.56914 2.78267 6.33108 1.80317C8.09303 0.823675 10.0787 0.317439 12.0945 0.33382C14.1104 0.350202 16.0876 0.88864 17.8334 1.89664ZM15.7334 14.667C15.5124 14.4504 15.2145 14.3305 14.9052 14.3335C14.5958 14.3366 14.3003 14.4624 14.0837 14.6833C13.8121 14.9606 13.4879 15.1809 13.1302 15.3312C12.7724 15.4816 12.3882 15.5591 12 15.5591C11.6119 15.5591 11.2277 15.4816 10.8699 15.3312C10.5121 15.1809 10.188 14.9606 9.91637 14.6833C9.69867 14.4675 9.40479 14.3461 9.09826 14.3452C8.79173 14.3444 8.49718 14.4642 8.27829 14.6788C8.0594 14.8934 7.93377 15.1855 7.92854 15.492C7.92332 15.7985 8.03893 16.0947 8.25037 16.3166C8.73918 16.8154 9.32259 17.2117 9.96645 17.4822C10.6103 17.7527 11.3017 17.8921 12 17.8921C12.6984 17.8921 13.3898 17.7527 14.0336 17.4822C14.6775 17.2117 15.2609 16.8154 15.7497 16.3166C15.9663 16.0957 16.0862 15.7978 16.0831 15.4884C16.0801 15.1791 15.9543 14.8836 15.7334 14.667ZM8.51171 8.49998L8.36354 8.50814C8.06826 8.54326 7.79754 8.68981 7.60668 8.91784C7.41583 9.14587 7.31925 9.43817 7.33667 9.73501C7.3541 10.0319 7.48422 10.3109 7.70044 10.515C7.91667 10.7191 8.20268 10.833 8.50004 10.8333L8.64821 10.8251C8.94349 10.79 9.21421 10.6435 9.40506 10.4154C9.59592 10.1874 9.6925 9.89512 9.67507 9.59827C9.65765 9.30142 9.52753 9.02243 9.3113 8.8183C9.09508 8.61417 8.80907 8.50031 8.51171 8.49998ZM15.5117 8.49998L15.3635 8.50814C15.0683 8.54326 14.7975 8.68981 14.6067 8.91784C14.4158 9.14587 14.3192 9.43817 14.3367 9.73501C14.3541 10.0319 14.4842 10.3109 14.7004 10.515C14.9167 10.7191 15.2027 10.833 15.5 10.8333L15.6482 10.8251C15.9435 10.79 16.2142 10.6435 16.4051 10.4154C16.5959 10.1874 16.6925 9.89512 16.6751 9.59827C16.6576 9.30142 16.5275 9.02243 16.3113 8.8183C16.0951 8.61417 15.8091 8.50031 15.5117 8.49998Z"
        fill={fill}
      />
    </svg>
  );
};

HappySmileIcon.propTypes = {
  className: PropTypes.string,
  fill: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string
};

HappySmileIcon.defaultProps = {
  className: '',
  fill: '#B1B1B1',
  width: '24px',
  height: '24px'
};

export const BellIcon = props => {
  const { className, fill, width, height } = props;
  return (
    <svg
      className={className}
      width={width}
      height={height}
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 448 512"
    >
      <path
        fill={fill}
        d="M224 0c-17.7 0-32 14.3-32 32v19.2C119 66 64 130.6 64 208v18.8c0 47-17.3 92.4-48.5 127.6l-7.4 8.3c-8.4 9.4-10.4 22.9-5.3 34.4S19.4 416 32 416h384c12.6 0 24-7.4 29.2-18.9s3.1-25-5.3-34.4l-7.4-8.3C401.3 319.2 384 273.8 384 226.8V208c0-77.4-55-142-128-156.8V32c0-17.7-14.3-32-32-32zm45.3 493.3c12-12 18.7-28.3 18.7-45.3H224 160c0 17 6.7 33.3 18.7 45.3s28.3 18.7 45.3 18.7s33.3-6.7 45.3-18.7z"
      />
    </svg>
  );
};

BellIcon.defaultProps = {
  className: '',
  fill: '#ffffff',
  width: '16px',
  height: '16px'
};

BellIcon.propTypes = ICON_PROP_TYPES;

export const MagnifierMinusIcon = props => {
  const { className, fill, width, height } = props;
  return (
    <svg fill={fill} width={width} height={height} viewBox="0 0 64 64" className={className}>
      <g>
        <path
          d="M45.414,36.586c-0.781-0.781-2.047-0.781-2.828,0L41,38.172l-3.811-3.811C40.192,30.728,42,26.071,42,21
		C42,9.42,32.579,0,21,0S0,9.42,0,21s9.421,21,21,21c5.071,0,9.728-1.808,13.361-4.811L38.172,41l-1.586,1.586
		c-0.781,0.781-0.781,2.047,0,2.828l18,18C54.977,63.805,55.488,64,56,64s1.023-0.195,1.414-0.586l6-6
		c0.781-0.781,0.781-2.047,0-2.828L45.414,36.586z M4,21c0-9.374,7.626-17,17-17s17,7.626,17,17s-7.626,17-17,17S4,30.374,4,21z
		 M56,59.171L40.828,44L44,40.829L59.172,56L56,59.171z"
        />
        <path d="M30,19H12c-1.104,0-2,0.896-2,2s0.896,2,2,2h18c1.104,0,2-0.896,2-2S31.104,19,30,19z" />
      </g>
    </svg>
  );
};

MagnifierMinusIcon.defaultProps = {
  className: '',
  fill: '#ffffff',
  width: '16px',
  height: '16px'
};

MagnifierMinusIcon.propTypes = ICON_PROP_TYPES;
